import { EARTH_CIRCUMFERENCE_IN_METERS, METERS_PER_CSS_PIXEL } from "../constants";

/**
 * @name getZoomForScaleDenominator
 * @description The inverse of `getScaleDenominator` — the zoom at which the map centre renders at "1:N".
 */
function getZoomForScaleDenominator({ scaleDenominator, latitude, tileSize }: { scaleDenominator: number; latitude: number; tileSize: number }): number {
	const latitudeRad = (latitude * Math.PI) / 180;
	const circumferenceAtLat = EARTH_CIRCUMFERENCE_IN_METERS * Math.cos(latitudeRad);
	const metersPerPixel = scaleDenominator * METERS_PER_CSS_PIXEL;

	return Math.log2(circumferenceAtLat / (tileSize * metersPerPixel));
}

export { getZoomForScaleDenominator };
